import apiClient from './apiClient';
import { GET_LIST_CUSTOMER_PAYMENT_URL } from './apiUrl';

const getCustomerPaymentApi = () => {
  return apiClient.get(GET_LIST_CUSTOMER_PAYMENT_URL);
};

export { getCustomerPaymentApi };
